module.exports = __webpack_public_path__ + "AvertaStd-Thin.svg?9d0a28b83c3f6447f850ac457f7150d5";